@if (templateHasAvailabilityOptions) {
  <section id="template-availability" @transitionWidth>
    <h3>Template availability</h3>
    <p>Select the pages where this template can be used</p>
    <div>
      <mat-select multiple placeholder="Select entities" (selectionChange)="availabilityChange()" [(value)]="selectedAvailabilityEntityTypes">
        <mat-select-trigger>
          @if (selectedAvailabilityEntityTypes.length === 0) {
            Select entities...
          }
          @if (selectedAvailabilityEntityTypes.length === 1) {
            {{ entitySelectedLabels }}
          }
          @if (selectedAvailabilityEntityTypes.length === 2) {
            {{ entitySelectedLabels[0] }} and {{ entitySelectedLabels[1] }}
          }
          @if (selectedAvailabilityEntityTypes?.length > 2) {
            <span>
              {{ entitySelectedLabels[0] }} (+{{ selectedAvailabilityEntityTypes.length - 1 }}
              more)
            </span>
          }
        </mat-select-trigger>
        @for (entity of availabilityEntityTypes; track entity.objectName) {
          <mat-option
            [value]="entity"
            [matTooltip]="entity.tooltip"
            matTooltipShowDelay="500"
            matTooltipPosition="after"
            >
            {{ entity.label }}
          </mat-option>
        }
      </mat-select>
    </div>
  </section>
}
